<template>
  <b-card class="cardStyle">
    <p class="mx-0 mt-2 title">
      <b-icon :icon="icon" scale="1.3"></b-icon>&nbsp; &nbsp;Site Activation Summary
    </p>
    <b-row class="mt-3" v-for="item in items" :key="item">
      <b-col class="infoTitle" cols="7">
        {{ item }}
      </b-col>
      <b-col class="info" cols="5">
        {{ siteActivationInfo[item] }}
      </b-col>
    </b-row>
    <div class="text-right infoTitle" style="font-size:11px;">
      *Calendar Days
    </div>
  </b-card>
</template>

<script>
  import moment from 'moment';
  export default {
    props: {
      milestones: Array,
      lastMilestoneAchieved: String,
      nextMilestonePlanned: String,
    },
    data() {
      return {
        icon: '',
        items: [
          'Site Activation Status',
          'Days* elapsed since Site Selection',
          'Days* elapsed since IIP Sent to Site',
          'Days* from today until planned Site Activation',
          'Last Milestone Achieved',
          'Next Milestone Planned',
        ],
        siteActivationStatus: '',
        daysElapsedSinceSiteSelection: 'N/A',
        daysElapsedSinceIIPSentToSite: 'N/A',
        daysFromSiteSelectionToActivation: 'N/A',
        daysFromIIPSentToSiteToActivation: 'N/A',
        daysUntilPlannedSiteActivation: 'N/A',

        siteActivationInfo: [],
      };
    },
    created() {
      this.checkStatus();
      this.setSiteActivationInfo();
    },
    methods: {
      checkStatus() {
        let findSiteActivation = this.milestones.find(
          el => el['milestoneName'] === 'Site Activated',
        );
        let findFSFV = this.milestones.find(
          el => el['milestoneName'] === 'Site FSFV Date' || el['milestoneName'] === 'Site FSFV',
        );
        if (findSiteActivation) {
          if (findSiteActivation['actualDate']) {
            this.siteActivationStatus = 'Completed';
          } else {
            this.siteActivationStatus = 'In Progress';
          }
        } else if (findFSFV && (findFSFV['actualDate'] || findFSFV['plannedDate'])) {
          this.siteActivationStatus = 'Completed';
        } else if (this.milestones.length > 0) {
          this.siteActivationStatus = 'In Progress';
        } else {
          this.siteActivationStatus = 'N/A';
        }
      },
      setSiteActivationInfo() {
        if (this.siteActivationStatus === 'Completed') {
          this.icon = 'circle-fill';
          this.calcForCompleted();
          this.siteActivationArrayInfo('Completed');
        } else if (this.siteActivationStatus === 'In Progress') {
          this.icon = 'circle-half';
          this.calcForInProgress();
          this.siteActivationArrayInfo('In Progress');
        } else {
          this.icon = 'circle';
          this.siteActivationArrayInfo('');
        }
      },
      calcForCompleted() {
        this.items = [
          'Site Activation Status',
          'Days* from Site Selection to Site Activation',
          'Days* from IIP Sent to Site Activation',
          'Days* from today until planned Site Activation',
          'Last Milestone Achieved',
          'Next Milestone Planned',
        ];
        this.daysUntilPlannedSiteActivation = 'Activation completed';
        let findSiteActivation = this.milestones.find(
          el => el['milestoneName'] === 'Site Activated',
        );
        let activationDate;
        if (!findSiteActivation) {
          let findFSFV = this.milestones.find(
            el => el['milestoneName'] === 'Site FSFV Date' || el['milestoneName'] === 'Site FSFV',
          );
          activationDate = findFSFV['plannedDate']
            ? moment(findFSFV['plannedDate'])
            : moment(findFSFV['actualDate']);
        }
        if (findSiteActivation) {
          activationDate = moment(findSiteActivation['actualDate']);
        }

        let findSiteSelection = this.milestones.find(
          el => el['milestoneName'] === 'Site Selection Date',
        );
        if (findSiteSelection && findSiteSelection['actualDate']) {
          this.daysFromSiteSelectionToActivation = activationDate.diff(
            moment(findSiteSelection['actualDate']),
            'days',
          );
        }

        let findIIPSentToSite = this.milestones.find(
          el => el['milestoneName'] === 'IIP Sent to Site',
        );
        if (findIIPSentToSite && findIIPSentToSite['actualDate']) {
          this.daysFromIIPSentToSiteToActivation = activationDate.diff(
            moment(findIIPSentToSite['actualDate']),
            'days',
          );
        }
      },
      calcForInProgress() {
        const today = moment(new Date());
        let findSiteActivation = this.milestones.find(
          el => el['milestoneName'] === 'Site Activated',
        );
        if (findSiteActivation && findSiteActivation['plannedDate']) {
          this.daysUntilPlannedSiteActivation = moment(findSiteActivation['plannedDate']).diff(
            today,
            'days',
          );
        }

        let findSiteSelection = this.milestones.find(
          el => el['milestoneName'] === 'Site Selection Date',
        );
        if (findSiteSelection && findSiteSelection['actualDate']) {
          this.daysElapsedSinceSiteSelection = today.diff(
            moment(findSiteSelection['actualDate']),
            'days',
          );
        }

        let findIIPSentToSite = this.milestones.find(
          el => el['milestoneName'] === 'IIP Sent to Site',
        );
        if (findIIPSentToSite && findIIPSentToSite['actualDate']) {
          this.daysElapsedSinceIIPSentToSite = today.diff(
            moment(findIIPSentToSite['actualDate']),
            'days',
          );
        }
      },
      siteActivationArrayInfo(status) {
        if (status === 'Completed') {
          this.siteActivationInfo[
            'Days* from IIP Sent to Site Activation'
          ] = this.daysFromIIPSentToSiteToActivation;
          this.siteActivationInfo[
            'Days* from Site Selection to Site Activation'
          ] = this.daysFromSiteSelectionToActivation;
          this.siteActivationInfo['Next Milestone Planned'] = this.nextMilestonePlanned;
        } else {
          this.siteActivationInfo[
            'Days* elapsed since Site Selection'
          ] = this.daysElapsedSinceSiteSelection;
          this.siteActivationInfo[
            'Days* elapsed since IIP Sent to Site'
          ] = this.daysElapsedSinceIIPSentToSite;
          this.siteActivationInfo['Next Milestone Planned'] = this.nextMilestonePlanned;
        }

        this.siteActivationInfo[
          'Days* from today until planned Site Activation'
        ] = this.daysUntilPlannedSiteActivation;
        this.siteActivationInfo['Site Activation Status'] = this.siteActivationStatus;
        this.siteActivationInfo['Last Milestone Achieved'] = this.lastMilestoneAchieved;
      },
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0060aa;
    padding-bottom: 1.7rem;
  }
  .infoTitle {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }
  .info {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #383838;
  }
</style>
